{
  "pages": {
    "orderListTitle": "Đơn lab",
    "orderCreateTitle": "Tạo đơn lab",
    "orderEditTitle": "Sửa đơn lab",
    "orderDetailsTitle": "Chi tiết đơn lab",
    "orderDetailsWithCode": "Đơn lab {{code}}",
    "partnerListTitle": "Đối tác labo",
    "partnerAddTitle": "Thêm đối tác xưởng",
    "partnerEditTitle": "Sửa đối tác xưởng",
    "orderPermissionDenied": "Bạn không có quyền xem đơn lab.",
    "orderCreatePermissionDenied": "Bạn không có quyền tạo đơn lab.",
    "partnerPermissionDenied": "Bạn không có quyền xem đối tác xưởng.",
    "partnerCreatePermissionDenied": "Bạn không có quyền thêm đối tác xưởng.",
    "partnerUpdatePermissionDenied": "Bạn không có quyền sửa đối tác xưởng.",
    "kanbanTitle": "Kanban đơn lab",
    "orderNotFound": "Không tìm thấy đơn lab.",
    "partnerNotFound": "Không tìm thấy đối tác"
  },
  "masterHub": {
    "tabsAria": "Danh mục Labo"
  },
  "partnerForm": {
    "addContact": "Thêm liên hệ",
    "removeContact": "Xóa liên hệ",
    "contactN": "Liên hệ {{n}}",
    "contactPersonN": "Người liên hệ {{n}}",
    "placeholders": {
      "code": "Ví dụ: LAB-KHAI-NGUYEN",
      "name": "Ví dụ: Labo Khai Nguyên",
      "contactName": "Nhập họ và tên",
      "contactPerson": "Nhập họ và tên",
      "phone": "Ví dụ: 0901234567",
      "email": "Nhập email",
      "defaultLeadTimeDays": "7",
      "paymentTerms": "Ví dụ: Thanh toán trong 30 ngày",
      "notes": "Ví dụ: Giao hàng tận phòng khám",
      "street": "Nhập số nhà, tên đường",
      "unitPrice": "0",
      "rowLeadTimeDays": "7"
    },
    "validation": {
      "codeRequired": "Mã xưởng là bắt buộc",
      "codeTooLong": "Mã xưởng tối đa {{max}} ký tự",
      "nameRequired": "Tên xưởng là bắt buộc",
      "nameTooLong": "Tên xưởng tối đa {{max}} ký tự",
      "contactTooLong": "Họ và tên tối đa {{max}} ký tự",
      "contactNameRequired": "Nhập họ và tên khi có SĐT hoặc email",
      "emailTooLong": "Email tối đa {{max}} ký tự",
      "leadTimeRequired": "Số ngày làm mặc định là bắt buộc",
      "paymentTermsTooLong": "Điều khoản thanh toán tối đa {{max}} ký tự",
      "notesTooLong": "Ghi chú tối đa {{max}} ký tự"
    }
  },
  "masterSidebar": {
    "title": "Labo",
    "partners": "Đối tác labo",
    "workTypes": "Loại phục hình",
    "materials": "Vật liệu",
    "shades": "Màu sắc"
  },
  "labCatalog": {
    "pages": {
      "title": "Loại phục hình, vật liệu & màu lab",
      "workTypesTitle": "Loại phục hình",
      "materialsTitle": "Vật liệu",
      "shadesTitle": "Màu sắc",
      "permissionDenied": "Bạn không có quyền xem danh mục lab."
    },
    "tabs": {
      "workTypes": "Loại phục hình",
      "materials": "Vật liệu",
      "shades": "Màu sắc"
    },
    "fields": {
      "name": "Tên",
      "code": "Mã",
      "sortOrder": "Thứ tự",
      "status": "Trạng thái",
      "kind": "Nguồn"
    },
    "form": {
      "name": "Tên",
      "sortOrder": "Thứ tự",
      "placeholders": {
        "name": "Ví dụ: Sứ Emax",
        "sortOrder": "100"
      }
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "type": {
      "system": "Hệ thống",
      "custom": "Tùy chỉnh"
    },
    "actions": {
      "add": "Thêm",
      "addWorkType": "Thêm loại",
      "addMaterial": "Thêm vật liệu",
      "deactivate": "Ngừng dùng",
      "deactivating": "Đang ngừng dùng...",
      "reactivate": "Bật lại",
      "reactivating": "Đang bật lại...",
      "history": "Lịch sử"
    },
    "history": {
      "title": "Lịch sử danh mục",
      "empty": "Chưa có thay đổi nào trên mục này."
    },
    "search": {
      "placeholder": "Tìm theo tên hoặc mã"
    },
    "table": {
      "workTypes": {
        "name": "Loại phục hình",
        "code": "Mã loại"
      },
      "empty": "Chưa có mục nào",
      "noFound": "Không tìm thấy kết quả",
      "createdAt": "Ngày tạo",
      "updatedAt": "Ngày sửa",
      "createdBy": "Người tạo",
      "updatedBy": "Người cập nhật"
    },
    "dialogs": {
      "addTitle": "Thêm mục",
      "editTitle": "Sửa mục",
      "addWorkType": "Thêm loại phục hình",
      "editWorkType": "Sửa loại phục hình",
      "addMaterial": "Thêm vật liệu",
      "editMaterial": "Sửa vật liệu",
      "addShade": "Thêm màu sắc",
      "editShade": "Sửa màu sắc",
      "confirmDeactivate": "Ngừng dùng «{{name}}»?"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên",
      "nameTooLong": "Tên tối đa {{max}} ký tự",
      "sortOrderInvalid": "Thứ tự phải là số không âm"
    },
    "toasts": {
      "created": "Đã thêm mục",
      "updated": "Đã cập nhật mục",
      "deactivated": "Đã ngừng dùng mục",
      "reactivated": "Đã bật lại mục",
      "saveFailed": "Không lưu được mục",
      "deactivateFailed": "Không ngừng dùng được mục",
      "reactivateFailed": "Không bật lại được mục",
      "loadFailed": "Không tải được danh mục"
    }
  },
  "orderStatus": {
    "draft": "Nháp",
    "sent": "Đã gửi đi",
    "received": "Đã nhận về",
    "completed": "Hoàn tất",
    "cancelled": "Đã hủy",
    "all": "Tất cả trạng thái"
  },
  "purpose": {
    "treatment": "Điều trị",
    "demo": "Mẫu tư vấn / đào tạo",
    "stock": "Hàng loạt / tồn dùng dần",
    "lab_test": "Test xưởng mới",
    "ops": "Gia công / bảo hành nội bộ",
    "all": "Tất cả loại đơn"
  },
  "remakeReasons": {
    "lab_fault": "Lỗi xưởng (bảo hành)",
    "clinical_fault": "Lỗi lâm sàng",
    "patient_change": "Bệnh nhân đổi ý"
  },
  "remakeReasonHints": {
    "lab_fault": "Chi phí lab = 0.",
    "clinical_fault": "Giữ chi phí lab. Trừ hoa hồng bác sĩ chưa làm ở bước này.",
    "patient_change": "Giữ chi phí lab. Thu thêm bệnh nhân chưa làm ở bước này."
  },
  "partnerStatus": {
    "active": "Đang hoạt động",
    "inactive": "Ngừng hoạt động",
    "all": "Tất cả trạng thái"
  },
  "workTypes": {
    "pfm": "Sứ kim loại",
    "titan": "Sứ Titan",
    "crom_cobalt": "Sứ Crom Cobalt",
    "precious": "Sứ quý kim",
    "lava_plus": "Sứ Lava Plus",
    "cercon_ht": "Sứ Cercon HT",
    "ceramill_zolid": "Sứ Ceramill Zolid",
    "ddbio": "Sứ DDbio",
    "post_core": "Cùi giả",
    "framework": "Hàm khung",
    "framework_attachment": "Hàm khung liên kết",
    "mesh": "Lưới hàm",
    "flexible_resin": "Nhựa dẻo",
    "hard_resin": "Nhựa cứng",
    "bleach_tray": "Máng tẩy",
    "temp_crown": "Răng tạm",
    "wax_rim": "Gối sáp",
    "custom_tray": "Khay cá nhân",
    "veneer_emax": "Veneer Emax - Ivoclar",
    "emax": "Sứ Emax - Ivoclar",
    "veneer_zirconia": "Veneer Zirconia Aidite",
    "expander_removable": "Khí cụ nong hàm tháo lắp",
    "expander_fixed": "Khí cụ nong hàm cố định",
    "hawley": "Hàm duy trì Hawley",
    "clear_retainer": "Hàm duy trì bằng nhựa trong suốt",
    "implant_guide": "Máng hướng dẫn phẫu thuật Implant",
    "inlay_onlay_overlay": "Inlay/Onlay/Overlay",
    "crown": "Răng sứ / Crown",
    "bridge_pontic": "Cầu răng (pontic)",
    "bridge_retainer": "Cầu răng (retainer)",
    "veneer": "Veneer",
    "inlay_onlay": "Inlay / Onlay",
    "full_denture": "Hàm giả toàn phần",
    "partial_denture": "Hàm giả bán phần",
    "implant_crown": "Răng sứ trên implant",
    "implant_abutment": "Abutment",
    "night_guard": "Máng nhai",
    "ortho_appliance": "Khí cụ chỉnh nha",
    "other": "Khác"
  },
  "materials": {
    "zirconia": "Zirconia",
    "emax": "E.max",
    "pfm": "PFM (sứ kim loại)",
    "full_metal": "Kim loại toàn phần",
    "acrylic": "Nhựa acrylic",
    "composite": "Composite",
    "titanium": "Titanium",
    "other": "Khác"
  },
  "fields": {
    "partner": "Đối tác xưởng",
    "labo": "Labo",
    "partnerOptionalDraft": "Đối tác xưởng (tùy chọn lúc nháp)",
    "partnerCode": "Mã labo",
    "partnerName": "Tên labo",
    "contacts": "Người liên hệ",
    "contactName": "Họ và tên",
    "contactPerson": "Người liên hệ",
    "phone": "Điện thoại",
    "email": "Email",
    "defaultLeadTimeDays": "Số ngày làm mặc định",
    "status": "Trạng thái",
    "address": "Địa chỉ",
    "street": "Địa chỉ (Số nhà, Tên đường)",
    "province": "Tỉnh/Thành phố",
    "ward": "Phường/Xã",
    "paymentTerms": "Điều khoản thanh toán",
    "notes": "Ghi chú",
    "dueDate": "Hạn trả",
    "labCost": "Chi phí xưởng (VND)",
    "labCostOptional": "Chi phí xưởng (VND, tùy chọn)",
    "labCostFromLines": "Chi phí xưởng (tổng dòng)",
    "quotedLabCost": "Giá tạm (lúc gửi)",
    "actualLabCost": "Giá thật (hóa đơn)",
    "workingLabCost": "Giá hóa đơn / điều chỉnh",
    "subtotal": "Tạm tính",
    "discountAmount": "Giảm giá",
    "netLabCost": "Thành tiền",
    "internalNotes": "Ghi chú nội bộ",
    "detailedRequirements": "Yêu cầu chi tiết",
    "enclosedItems": "Gửi kèm phiếu labo",
    "enclosedItemsOther": "Gửi kèm khác",
    "enclosedItemsOtherPlaceholder": "Nhập nội dung gửi kèm khác…",
    "enclosedItemsPlaceholder": "Chọn hoặc nhập gửi kèm…",
    "enclosedItemsHint": "Chọn từ danh sách, hoặc gõ rồi Enter để thêm mục khác.",
    "pendingImages": "File đính kèm (tối đa {{count}})",
    "patient": "Bệnh nhân",
    "patientOptional": "Bệnh nhân (tùy chọn)",
    "patientSearchPlaceholder": "Tìm tên / SĐT",
    "purpose": "Loại đơn",
    "dentist": "Bác sĩ",
    "dentistInCharge": "Bác sĩ phụ trách",
    "clinic": "Chi nhánh",
    "sentBy": "Người gửi",
    "receivedBy": "Người nhận",
    "receivedAt": "Nhận lúc",
    "treatmentPlan": "Kế hoạch điều trị",
    "treatmentPlanItem": "Hạng mục điều trị",
    "sentAt": "Gửi lúc",
    "amount": "Số tiền",
    "expenseDate": "Ngày chi",
    "paymentMethod": "Hình thức thanh toán",
    "expenseNotes": "Ghi chú phiếu chi",
    "fromDate": "Từ ngày",
    "toDate": "Đến ngày",
    "originalOrder": "Đơn gốc",
    "remakeOrders": "Đơn làm lại",
    "remakeReason": "Nguyên nhân làm lại",
    "warranty": "Bảo hành",
    "adjustNotes": "Lý do điều chỉnh",
    "priceList": "Bảng giá xưởng",
    "unitPrice": "Đơn giá",
    "anyMaterial": "Mọi vật liệu"
  },
  "placeholders": {
    "clinic": "Chọn chi nhánh",
    "treatmentPlanItem": "Chọn hạng mục điều trị",
    "treatmentPlan": "Chọn kế hoạch điều trị",
    "dentist": "Chọn bác sĩ",
    "partner": "Chọn xưởng",
    "labo": "Chọn labo",
    "sentBy": "Chọn người gửi",
    "dueDate": "dd/mm/yyyy",
    "internalNotes": "Nhập ghi chú nội bộ",
    "detailedRequirements": "Nhập yêu cầu gửi xưởng",
    "workType": "Chọn loại phục hình",
    "shade": "Chọn màu",
    "material": "Chọn vật liệu",
    "quantity": "1",
    "unitPrice": "0",
    "technicalNotes": "Ghi chú kỹ thuật",
    "discountAmount": "0"
  },
  "table": {
    "orderCode": "Mã đơn",
    "patient": "Bệnh nhân",
    "partner": "Xưởng",
    "dueDate": "Hạn trả",
    "status": "Trạng thái",
    "actions": "Thao tác",
    "code": "Mã labo",
    "partnerName": "Tên labo",
    "contact": "Người liên hệ",
    "leadTimeDays": "Số ngày làm",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày sửa",
    "createdBy": "Người tạo",
    "updatedBy": "Người cập nhật",
    "workType": "Loại phục hình",
    "toothFdi": "Răng",
    "shade": "Màu",
    "material": "Vật liệu",
    "qty": "SL",
    "unitPrice": "Đơn giá",
    "technicalNotes": "Ghi chú",
    "type": "Loại",
    "tooth": "Răng",
    "orderCount": "Số đơn",
    "labCost": "Chi phí lab",
    "expensed": "Đã ghi chi",
    "dentist": "Bác sĩ",
    "avgDays": "TB ngày (sent → completed)"
  },
  "lineEditor": {
    "title": "Hạng mục lab",
    "listTitle": "Danh sách phục hình",
    "addLine": "Thêm dòng",
    "empty": "Chưa có hạng mục",
    "toothPlaceholder": "16, 17",
    "lineTotal": "Tổng theo dòng"
  },
  "discountEditor": {
    "choose": "Chọn ưu đãi",
    "fixed": "Số tiền",
    "fixedSymbol": "đ",
    "percent": "%",
    "fixedPlaceholder": "Nhập số tiền",
    "percentPlaceholder": "Nhập %",
    "exceedsBase": "Không vượt quá {{max}}",
    "percentRange": "Từ 1 đến 100"
  },
  "filters": {
    "partner": "Xưởng",
    "patient": "Bệnh nhân",
    "dentist": "Bác sĩ",
    "allDentists": "Tất cả bác sĩ",
    "clinic": "Chi nhánh",
    "status": "Trạng thái",
    "purpose": "Loại đơn",
    "dueDateRange": "Ngày hạn",
    "overdueOnly": "Chỉ trễ hạn",
    "overdue": "Trễ hạn",
    "allClinics": "Tất cả chi nhánh",
    "selectPatient": "Chọn bệnh nhân"
  },
  "catalog": {
    "searchOrders": "Tìm mã đơn hoặc tên bệnh nhân",
    "searchPartners": "Tìm đối tác",
    "emptyOrders": "Chưa có đơn lab",
    "emptyPartners": "Chưa có đối tác xưởng",
    "createOrder": "Tạo đơn lab",
    "addPartner": "Thêm đối tác",
    "daysUnit": "{{count}} ngày",
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  },
  "dueDate": {
    "overdue": "Trễ hạn",
    "dueSoon": "Sắp đến hạn",
    "dueSoonWithDate": "{{date}} — Sắp đến hạn"
  },
  "timeline": {
    "orderCancelled": "Đơn đã hủy",
    "current": "(hiện tại)",
    "stepNotReached": "Chưa qua bước {{status}}",
    "historyTitle": "Các vòng gửi",
    "adjustRound": "Gửi điều chỉnh"
  },
  "sections": {
    "workTicket": "Phiếu gia công",
    "technicalFiles": "Tệp đính kèm",
    "progress": "Tiến độ",
    "clinicalContext": "Ngữ cảnh lâm sàng",
    "activityLog": "Nhật ký",
    "labCost": "Chi phí xưởng",
    "attachments": "File đính kèm",
    "statusHistory": "Lịch sử trạng thái",
    "activityHistory": "Lịch sử hoạt động",
    "recentOrders": "Đơn gần đây",
    "priceList": "Bảng giá"
  },
  "partnerHistory": {
    "title": "Lịch sử đối tác labo",
    "empty": "Chưa có thay đổi nào trên đối tác này."
  },
  "actions": {
    "history": "Lịch sử",
    "moreActions": "Thêm thao tác",
    "refresh": "Làm mới",
    "view": "Xem",
    "viewDetails": "Xem chi tiết",
    "edit": "Sửa",
    "save": "Lưu",
    "saving": "Đang lưu...",
    "saveDraft": "Lưu nháp",
    "savingDraft": "Đang lưu nháp...",
    "cancel": "Hủy",
    "close": "Đóng",
    "send": "Gửi",
    "sendToLab": "Gửi xưởng",
    "adjustSend": "Gửi điều chỉnh",
    "editDraft": "Sửa nháp",
    "editDueDateNotes": "Sửa hạn trả / ghi chú",
    "remake": "Làm lại",
    "cancelOrder": "Hủy đơn",
    "deleteDraft": "Xóa nháp",
    "delete": "Xóa",
    "back": "Quay lại",
    "deactivate": "Ngừng hoạt động",
    "deactivating": "Đang ngừng hoạt động...",
    "recordExpense": "Ghi phiếu chi",
    "viewExpense": "Xem phiếu chi",
    "apply": "Áp dụng",
    "createDraft": "Tạo đơn nháp",
    "printSlip": "In phiếu gửi",
    "downloadPdf": "Tải PDF",
    "addPriceRow": "Thêm dòng giá",
    "uploadFile": "Tải file lên"
  },
  "enclosedItems": {
    "impression_tray": "Khay lấy dấu",
    "abutment": "Abutment",
    "coping": "Coping",
    "analog": "Analog",
    "bite_wax": "Sáp cắn",
    "opposing_arch": "Hàm đối",
    "reference_arch": "Hàm tham khảo"
  },
  "pendingImages": {
    "unsupportedFormat": "Định dạng file không được hỗ trợ.",
    "maxReached": "Chỉ có thể chọn tối đa {{count}} file.",
    "uploadFailed": "Tạo đơn thành công nhưng tải file thất bại. Bạn có thể tải lại ở trang chi tiết."
  },
  "dialogs": {
    "sendOrderTitle": "Gửi đơn lab",
    "sendOrderBody": "Xác nhận gửi đơn đến xưởng? Cần có đối tác, hạn trả, người gửi và ít nhất một hạng mục.",
    "receiveOrderTitle": "Nhận đơn lab về",
    "receiveOrderBody": "Xác nhận phòng khám đã nhận phục hình từ xưởng.",
    "cancelOrderTitle": "Hủy đơn lab",
    "cancelOrderBody": "Bạn có chắc muốn hủy đơn này?",
    "deleteDraftTitle": "Xóa đơn nháp",
    "deleteDraftBody": "Thao tác này không thể hoàn tác.",
    "recordExpenseTitle": "Ghi phiếu chi",
    "recordExpenseBody": "Tạo phiếu chi cho đơn lab {{code}} — danh mục Chi phí lab.",
    "createFromTreatmentTitle": "Tạo đơn lab từ hạng mục KHT",
    "treatmentPlanLabel": "Kế hoạch: {{name}}",
    "toothLabel": "Răng: {{numbers}}",
    "deactivatePartner": "Ngừng hoạt động đối tác xưởng này?",
    "remakeTitle": "Tạo đơn làm lại",
    "remakeBody": "Tạo đơn nháp mới từ đơn {{code}}. Hạng mục đang có đơn chạy sẽ bị từ chối.",
    "remakeReason": "Nguyên nhân làm lại",
    "warranty": "Bảo hành (chi phí lab = 0)",
    "adjustTitle": "Gửi điều chỉnh",
    "adjustBody": "Gửi lại đơn {{code}} cho xưởng trên cùng phiếu — không tạo đơn mới. Ghi rõ lý do thử không vừa."
  },
  "expense": {
    "recorded": "Đã ghi chi: {{code}}",
    "amountLabel": "Số tiền: {{amount}}",
    "editInDraftHint": "(sửa trong chế độ Sửa nháp)"
  },
  "attachments": {
    "emptyTitle": "Chưa có file đính kèm",
    "confirmDelete": "Xóa file này?",
    "supportedFormats": "JPG, PNG, PDF, DOC, DICOM, STL…"
  },
  "print": {
    "printSlip": "In phiếu gửi xưởng",
    "downloadSlip": "Tải phiếu gửi xưởng",
    "downloadPdf": "Tải PDF",
    "disabledTooltip": "Không thể in phiếu gửi xưởng cho đơn đã hủy",
    "printFailed": "Không thể in phiếu gửi xưởng",
    "downloadFailed": "Không thể tải phiếu gửi xưởng",
    "downloadSuccess": "Đã tải phiếu gửi xưởng",
    "ariaDownload": "Tải phiếu gửi xưởng",
    "ariaPrint": "In phiếu gửi xưởng"
  },
  "validation": {
    "patientRequired": "Vui lòng chọn bệnh nhân",
    "patientRequiredForTreatment": "Đơn điều trị cần chọn bệnh nhân",
    "treatmentPlanItemRequired": "Đơn điều trị cần chọn hạng mục kế hoạch",
    "treatmentPlanRequired": "Đơn điều trị cần chọn kế hoạch điều trị",
    "dentistRequiredForTreatment": "Đơn điều trị cần chọn bác sĩ phụ trách",
    "remakeReasonRequired": "Chọn nguyên nhân làm lại",
    "noLabEligibleItems": "Bệnh nhân chưa có hạng mục bật đơn lab. Tạo từ kế hoạch điều trị.",
    "noTreatmentPlans": "Bệnh nhân chưa có kế hoạch điều trị",
    "clinicRequired": "Vui lòng chọn chi nhánh",
    "partnerRequired": "Vui lòng chọn labo",
    "atLeastOneLine": "Thêm ít nhất một hạng mục lab",
    "dueDateRequired": "Hạn trả là bắt buộc",
    "sentByRequired": "Vui lòng chọn người gửi",
    "receivedByRequired": "Vui lòng chọn người nhận",
    "adjustNotesRequired": "Vui lòng ghi lý do điều chỉnh",
    "partnerCodeNameRequired": "Mã và tên xưởng là bắt buộc",
    "invalidLabCost": "Chi phí xưởng không hợp lệ",
    "discountExceedsLabCost": "Giảm giá không được lớn hơn chi phí xưởng",
    "orderNotEditable": "Đơn này không sửa được",
    "priceListWorkTypeRequired": "Mỗi dòng bảng giá cần loại công việc",
    "priceListUnitPrice": "Đơn giá không hợp lệ",
    "priceListLeadTime": "Số ngày làm trên bảng giá không hợp lệ",
    "priceListDuplicate": "Trùng loại công việc và vật liệu trong bảng giá"
  },
  "toasts": {
    "orderDraftCreated": "Đã tạo đơn lab (nháp)",
    "orderUpdated": "Đã lưu đơn lab",
    "orderCreatedFromTreatment": "Đã tạo đơn lab {{code}}",
    "orderCreateFailed": "Không thể tạo đơn lab",
    "orderCreateFromTreatmentFailed": "Không tạo được đơn lab",
    "orderListLoadFailed": "Không tải được danh sách đơn lab",
    "invalidStatusTransition": "Không thể chuyển trạng thái này",
    "orderLoadFailed": "Không tải được đơn lab",
    "draftUpdated": "Đã cập nhật nháp",
    "opsNotesUpdated": "Đã cập nhật hạn trả và ghi chú",
    "remakeCreated": "Đã tạo đơn làm lại {{code}}",
    "remakeFailed": "Không tạo được đơn làm lại",
    "updateFailed": "Không thể cập nhật",
    "orderSent": "Đã gửi đơn lab",
    "orderAdjusted": "Đã gửi điều chỉnh",
    "adjustFailed": "Không gửi được điều chỉnh",
    "sendFailed": "Không thể gửi đơn",
    "statusChanged": "Đã chuyển sang: {{status}}",
    "statusChangeFailed": "Không thể đổi trạng thái",
    "orderCancelled": "Đã hủy đơn lab",
    "cancelFailed": "Không thể hủy đơn",
    "draftDeleted": "Đã xóa đơn nháp",
    "deleteFailed": "Không thể xóa",
    "labCostUpdated": "Đã cập nhật chi phí xưởng",
    "labCostUpdateFailed": "Không thể cập nhật chi phí",
    "expenseRecorded": "Đã ghi phiếu chi",
    "expenseRecordFailed": "Không thể ghi phiếu chi",
    "partnerCreated": "Đã thêm đối tác xưởng",
    "partnerCreateFailed": "Không thể tạo đối tác",
    "partnerUpdated": "Đã cập nhật đối tác xưởng",
    "partnerDeactivated": "Đã ngừng hoạt động đối tác",
    "partnerActionFailed": "Thao tác thất bại",
    "partnerListLoadFailed": "Không tải được danh sách đối tác xưởng",
    "partnerLoadFailed": "Không tải được thông tin đối tác",
    "activityEmpty": "Chưa có hoạt động nào liên quan đến đơn lab này."
  },
  "views": {
    "label": "Chế độ xem",
    "list": "Danh sách",
    "kanban": "Kanban"
  },
  "kanban": {
    "emptyColumn": "Không có đơn",
    "truncated": "Đang hiện {{shown}} / {{total}} đơn. Thu hẹp bộ lọc để xem đủ."
  },
  "detail": {
    "lineCount": "{{count}} dòng",
    "noSlipNotes": "Chưa có gửi kèm hoặc yêu cầu chi tiết"
  },
  "misc": {
    "notAvailable": "—"
  },
  "priceList": {
    "empty": "Chưa có bảng giá",
    "leadTimeDays": "Ngày làm"
  },
  "partnerStats": {
    "orderCount": "Số đơn",
    "overdueCount": "Trễ hạn",
    "totalLabCost": "Tổng chi phí lab",
    "totalExpensed": "Đã ghi chi",
    "emptyOrders": "Chưa có đơn lab với xưởng này",
    "loadFailed": "Không tải được thống kê đối tác",
    "ordersLoadFailed": "Không tải được đơn của xưởng này",
    "kpiDialog": {
      "orderCount": "Đơn lab — {{name}}",
      "overdueCount": "Đơn trễ hạn — {{name}}",
      "totalLabCost": "Chi phí lab theo đơn — {{name}}",
      "totalExpensed": "Đơn đã ghi chi — {{name}}",
      "showing": "Hiển thị {{count}} / {{total}} đơn"
    }
  }
}
